// CLASSES

export function ensureClassesExists() {
    if (!window.Emptylegs) window.Emptylegs = {}
    if (!window.Emptylegs.aircraftClasses) window.Emptylegs.aircraftClasses = []
}
export function getAircraftClasses() {
    ensureClassesExists()
    return window.Emptylegs.aircraftClasses
}
export function setAircraftClasses(items) {
    ensureClassesExists()
    window.Emptylegs.aircraftClasses = items;
}


// COMPARED

export function ensureComparedExists() {
    if (!window.Emptylegs) window.Emptylegs = {}
    if (!window.Emptylegs.aircraftsCompared) window.Emptylegs.aircraftsCompared = []
}
export function getAircraftsCompared() {
    ensureComparedExists()
    return window.Emptylegs.aircraftsCompared
}
export function getAircraftCompared(id) {
    return window.Emptylegs.aircraftsCompared.find(e => e.id == id)
}
export function setAircraftsCompared(items) {
    ensureComparedExists()
    window.Emptylegs.aircraftsCompared = items;
}
export function setAircraftCompared(item) {
    ensureComparedExists()
    window.Emptylegs.aircraftsCompared.push(item);
    raiseEvent('react.aircraftComparedAdded');
}
export function removeAircraftCompared(id) {
    ensureComparedExists()
    window.Emptylegs.aircraftsCompared = window.Emptylegs.aircraftsCompared.filter(e => e.id != id);
    raiseEvent('react.aircraftComparedRemoved');
}
export function hasAircraftCompared(id) {
    ensureComparedExists()
    return !!getAircraftCompared(id)
}
export function isAircraftComparedFlightInitiator(id, initiator_id) {
    const aircraft = getAircraftCompared(id);
    return !!aircraft ? aircraft.initiator_id == initiator_id : false;
}
export function switchAircraftCompared(item) {
    if (hasAircraftCompared(item.id))
        removeAircraftCompared(item.id)
    else
        setAircraftCompared(item)
}